import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import {Button, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import FaPencil from 'react-icons/lib/fa/pencil';
import NotFoundPage from '../NotFoundPage';
import ErrorComponent from '../ErrorComponent';

class ContactPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      contact: {},
      notFound: false,
      errors: []
    };

    this.fetchContact = this.fetchContact.bind(this);
    this.getFullName = this.getFullName.bind(this);
  }

  async componentDidMount() {
    try {
      await this.fetchContact();
    } catch (e) {
      this.setState({errors: e.errors});
    }
  }

  async fetchContact() {
    const contacts = (await GreenLeafApi.Contact.get({contactId: this.props.match.params.contactId})).data;
    if (contacts.length === 0) {
      this.setState({ notFound: true });
      return;
    }

    this.setState({contact: contacts[0]});
  }


  getFullName() {
    return this.state.contact.first_name ?
      this.state.contact.first_name + ' ' + this.state.contact.last_name : '';
  }


  render() {
    if (this.state.notFound) {
      return <NotFoundPage/>;
    }

    return (
      <div>

        <ErrorComponent error={this.state.errors}/>
        <h2 data-cy="contact-header" align="center">
          {this.getFullName()}
          <Link className="pull-right pr1" to={`/companies/${this.props.match.params.companyId}/contacts/${this.props.match.params.contactId}/edit`}>
            <Button data-cy="edit-contact-button" className="primary"><FaPencil /></Button>
          </Link>
        </h2>

        <Panel>
          <Panel.Heading data-cy="contact-info-panel">Info</Panel.Heading>
          <Panel.Body>
            <h4 data-cy="contact-email">Email Address: {this.state.contact.email}</h4>
            <h4 data-cy="contact-phone">Phone Number: {this.state.contact.phone}</h4>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default ContactPage;


// WEBPACK FOOTER //
// ./src/components/contacts/ContactPage.js